(() => {
  const popup = document.querySelector('[data-encore-newsletter-popup]');
  if (!popup) return;

  const storageKey = 'encoreNewsletterPopupState';
  const delay = 2000;
  let trigger = null;

  const storage = {
    get() {
      try {
        return window.localStorage.getItem(storageKey) || window.sessionStorage.getItem(storageKey);
      } catch (error) {
        return null;
      }
    },
    set(value) {
      try {
        window.localStorage.setItem(storageKey, value);
      } catch (error) {
        try {
          window.sessionStorage.setItem(storageKey, value);
        } catch (sessionError) {
          return;
        }
      }
    },
  };

  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ];

  const openPopup = () => {
    if (popup.classList.contains('is-visible')) return;

    trigger = document.activeElement;
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('encore-newsletter-popup-open');
    requestAnimationFrame(() => popup.classList.add('is-visible'));

    const firstInput = popup.querySelector('input[type="email"]');
    if (firstInput) firstInput.focus({ preventScroll: true });
  };

  const closePopup = (state = 'dismissed') => {
    storage.set(state);
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('encore-newsletter-popup-open');

    if (trigger && typeof trigger.focus === 'function') {
      trigger.focus({ preventScroll: true });
    }
  };

  const trapFocus = (event) => {
    if (event.key !== 'Tab' || !popup.classList.contains('is-visible')) return;

    const focusable = [...popup.querySelectorAll(focusableSelectors.join(','))].filter(
      (element) => element.offsetParent !== null
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  popup.querySelectorAll('[data-encore-newsletter-close]').forEach((button) => {
    button.addEventListener('click', () => closePopup());
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) closePopup();
    trapFocus(event);
  });

  if (popup.querySelector('.encore-newsletter-popup__message--success')) {
    storage.set('subscribed');
    openPopup();
    return;
  }

  if (storage.get()) return;

  window.setTimeout(openPopup, delay);
})();
